'use strict';

const selectors = {
    selectFaqCategory: '.js-select-faq-cat'
};

module.exports = {
    changeFaqCategory: function () {
        $('body').on('change', selectors.selectFaqCategory, function (e) {
            e.preventDefault();
            var category = $(this).val() || '';
            var url = new URL(window.location.href);
            url.searchParams.delete('cg');
            if (category) {
                url.searchParams.set('cg', category);
            }
            window.location.href = url;
        })
    }
}
